import { createSlice } from '@reduxjs/toolkit';

import { AsyncStatus, IdentifierOffset } from '../_declarations/globals';
import { ServicesResponse } from '../_declarations/services';
import { serviceDescriptionApi } from '../api/services';

type Services = IdentifierOffset & ServicesResponse;
interface ServicesState {
  error?: string;
  services: Services[];
  status?: AsyncStatus;
}

const legalNoteInitialState: ServicesState = {
  error: undefined,
  services: [],
  status: 'idle'
};

const servicesSlice = createSlice({
  extraReducers: (builder) => {
    builder.addCase(serviceDescriptionApi.fulfilled, (state, action) => {
      state.status = 'success';
      state.services = [...state.services, action.payload];
    });
  },
  initialState: legalNoteInitialState,
  name: 'services',
  reducers: {}
});

export default servicesSlice.reducer;
